<div class="modal-header">
  <h5 class="modal-title" id="checkInModalLabel">
    <i class="fas fa-check-circle"></i> Check-In
  </h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="circulationForm" style="width: 100%; background-color: white; padding: 20px; border-radius: 5px;">

    <!-- Member Selection (single) -->
    <div class="form-group">
      <label for="memberName">Member:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select the member checking in the item(s)."></i>
      <ng-select id="memberName"
                 [items]="members$"
                 bindLabel="firstname"
                 bindValue="id"
                 formControlName="memberName"
                 placeholder="Select a member">
      </ng-select>
      <small class="text-danger"
             *ngIf="submitted && circulationForm.get('memberName').invalid">
        Member is required.
      </small>
    </div>

    <!-- Item / Book Multi-Selection -->
    <div class="form-group">
      <label for="catalogItemNames">Items:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select one or more items to check in. Use Ctrl/Cmd+click or type to filter."></i>
      <ng-select id="catalogItemNames"
                 [items]="books$"
                 bindLabel="title"
                 bindValue="id"
                 formControlName="catalogItemNames"
                 placeholder="Select item(s)"
                 [multiple]="true"
                 [closeOnSelect]="false"
                 [clearable]="true">
      </ng-select>
      <small class="text-muted">You can select multiple items at once.</small>
      <small class="text-danger d-block"
             *ngIf="submitted && circulationForm.get('catalogItemNames').value?.length === 0">
        Please select at least one item.
      </small>
    </div>

    <!-- Return Due Date -->
    <div class="form-group mt-3">
      <label for="returnDueDate">Return Due Date:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select the due date for returning the item(s)."></i>
      <input type="date" class="form-control" id="returnDueDate"
             formControlName="returnDueDate">
      <small class="text-danger"
             *ngIf="submitted && circulationForm.get('returnDueDate').invalid">
        Return due date is required.
      </small>
    </div>

    <!-- Remember Return Date for Next Check-In -->
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="rememberReturnDate"
             formControlName="rememberReturnDate">
      <label class="form-check-label" for="rememberReturnDate">
        Remember return date for next check-in
      </label>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
  <button type="button" class="btn btn-outline-primary" (click)="add()">
    <i class="fas fa-check-circle"></i> Check In
  </button>
</div>